import { render } from "./ReferralProgram.vue?vue&type=template&id=25a267b6&scoped=true"
import script from "./ReferralProgram.vue?vue&type=script&lang=js"
export * from "./ReferralProgram.vue?vue&type=script&lang=js"

import "./ReferralProgram.vue?vue&type=style&index=0&id=25a267b6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a267b6"]])

export default __exports__